var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"fz-12 font-h6-regular contact-name"},[_vm._v(_vm._s(_vm._f("formatEmpty")(_vm.row.contactName)))]),_c('rd-text',{staticClass:"rd-text font-h6-regular",attrs:{"label":'手机号',"showCopy":true,"value":_vm._f("formatEmpty")(_vm.row.mobile)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }